import React from "react";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Ezugi from "../../assets/images/providers/Ezugi.gif";
import Evolution from "../../assets/images/providers/evo.gif";
import Vivo from "../../assets/images/providers/vivp.gif";
import Slots from "../../assets/images/providers/shine.gif";
import Supernowa from "../../assets/images/providers/supernowa.gif";
import Aviator from "../../assets/images/providers/Aviator.jpg";
import KingmakerImg from "../../assets/images/providers/kingmaker.gif";
import Exchange from "../../assets/images/providers/exchange.gif";
import play from "../../assets/images/play-button.png";
import Qtech from "../../assets/images/providers/Qtechgames.gif";
import Spribe from "../../assets/images/providers/Spribe.gif";
import Kingmaker from "../pages/privatePages/Kingmaker";

const ProvidersSlider = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const providersetting = {
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 4,
    arrows: true,
    autoplay: true,
    speed: 6000,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };
  return (
    <div className="ProvidersGamesSection">
      <Slider {...providersetting}>
        <div>
          <div className="games">
            <a href="/casino/ezugi">
              <img src={Ezugi} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Ezugi</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>{" "}
        <div>
          <div className="games">
            <a href="/casino/evolution">
              <img src={Evolution} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Evolution</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>{" "}
        <div>
          <div className="games">
            <a href="/casino/vivo">
              <img src={Vivo} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Vivo</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>{" "}
        <div>
          <div className="games">
            <a href="/casino/supernowa">
              <img src={Supernowa} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Supernowa</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>{" "}
        <div>
          <div className="games">
            <a href="/qtechlobby">
              <img src={Qtech} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Qtech</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>
        <div>
          <div className="games">
            <a href="/spribe">
              <img src={Spribe} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Spribe</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>
        <div>
          <div className="games">
            <a href="/kingmaker">
              <img src={KingmakerImg} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Kingmaker</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>
        <div>
          <div className="games">
            <a href="/slots">
              <img src={Slots} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Slots</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>
        <div>
          <div className="games">
            <a href="/casino/spribe/aviator">
              <img src={Aviator} alt="ezugi" />
              {/* <img src={play} className="play_button" /> */}
              <p>Aviator</p>
            </a>
            {/* <span class="focus-border">
              <i></i>
            </span> */}
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default ProvidersSlider;
